import React from "react";
import { Button, Row } from "react-bootstrap";
import { useHistory } from "react-router-dom";
type Props = { message: string };
export const UpgradeAlertBanner: React.FC<Props> = ({ message }) => {
  const history = useHistory();
  return (
    <>
      <span>{message}</span>
      <Button
        onClick={() => history.push("/account/upgrade")}
        className="mx-2"
        variant="link"
      >
        Upgrade
      </Button>
    </>
  );
};
